import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utilities.css';
import { initializeAuth } from './services/authInitializer';
import { installSessionInterceptor } from './services/sessionInterceptor';

// ✅ Check environment flag before initializing auth
const shouldInitializeAuth = () => {
  try {
    // Check if EventScribe guard is enabled
    const isEventScribeGuard = 
      process.env.REACT_APP_EVENTSCRIBE_WEBSITE_GUARD === "1" || 
      process.env.REACT_APP_EVENTSCRIBE_WEBSITE_GUARD === "true";
    
    return isEventScribeGuard;
  } catch (error) {
    console.error("Error checking auth flag:", error);
    return false; // Default to not initializing on error
  }
};

// Initialize authentication BEFORE React mounts (only for EventScribe guard)
if (shouldInitializeAuth()) {   
    initializeAuth();  
}

// Lock the chat as soon as any API rejects the access token
installSessionInterceptor();

// Mount React app
function mountApp() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {     
    return;
  }
  
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Initialize app - runs only once per page load
function initialize() {
  mountApp();
}

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize);
} else {
  // DOM already loaded, initialize immediately
  initialize();
}

reportWebVitals();
